import Dashboard from "./Dashboard/Dashboard";
import MerchantList from "./Merchant/MerchantList";
import TransactionHistory from "./Rds/TransactionHistory";
import AddReq from "./Requisition/AddReq";
import AllReq from "./Requisition/AllReq";

const apiuserRoutes = [
  {
    path: "/api-user/dashboard",
    element: <Dashboard />,
  },

  {
    path: "/api-user/merchants",
    element: <MerchantList />,
  },
  {
    path: "/api-user/acc/transaction",
    element: <TransactionHistory />,
  },

  {
    path: "/api-user/payments/all-req",
    element: <AllReq />,
  },
  {
    path: "/api-user/payments/add-req",
    element: <AddReq />,
  },
];

export default apiuserRoutes;
